module.exports = __webpack_public_path__ + "static/media/cuenta_contable-import.b8bb468a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cuenta_contable-import.csv
// module id = ./src/assets/cuenta_contable-import.csv
// module chunks = 11